import UpdateUserInfo from "@/components/widget/update-user-info";
import { config } from "@/config/base";

const UpdateUserInfoPage = () => {
  return (
    <div className="flex h-screen w-full items-center justify-center px-5">
      <div className="w-full max-w-[450px] rounded-md bg-white p-5 shadow-md">
        <h2 className="mb-10 text-center text-xl font-bold">{config.appConfig.texts.fullCartableTitle}</h2>
        <UpdateUserInfo />
      </div>
    </div>
  );
};
export default UpdateUserInfoPage;
